<template>
  <div>
    <button
      class="hoverable-button button-1-layout"
      @click="handleActivateEvent('ok')"
      handler-id="ok"
      :class="{ [btnClasses.ok]: true }"
    >
      OK button
    </button>
    <!-- A dynamic css class can be applied in runtime on each button, by the placing the class name in the corresponding variable inside btnClasses object. -->
    <!-- For instance, placing the value "active" in btnClassHolders.ok will apply the 'active' class on the ok button. -->
    <button
      class="hoverable-button button-2-layout"
      :class="{ [btnClasses.cancel]: true }"
      @click="handleActivateEvent('cancel')"
      handler-id="cancel"
    >
      Cancel button
    </button>
    <!-- <button class="hoverable-button button-2-layout" @click="handleCancelButton" handler-id="cancel">Cancel button</button> -->
  </div>
</template>

<script>
import handHoverMixin from '../../mixins/hand-hover-mixin.js';
import { eventTypes } from '../../config/config';
export default {
  mixins: [handHoverMixin],
  data() {
    return {
      eventTypes,
      btnClasses: {
        ok: '',
        cancel: ''
      }
    };
  },
  methods: {
    // The methods handleBtnActivate, handleBtnHover and handleBtnUnhover
    // have to be implemented in every screen intended to work with hover events.
    // The handlerId identifying the button will be passed to it by CamLayoutMediator.
    // It will be taken from the button's "handler-id" attribute.
    // handleHandEvent(eventType, handlerId) {
    //   // switch (handlerId) {
    //   //   case 'ok':
    //   //     this.handleOkButton();
    //   //     break;
    //   //   case 'cancel':
    //   //     this.handleCancelButton();
    //   //     break;
    //   //   default:
    //   //     this.routeToLevel(handlerId);
    //   // }
    //   if (eventType === eventTypes.HOVER) {
    //     this.handleBtnHover(handlerId);
    //     return;
    //   }
    //   if (eventType === eventTypes.ACTIVATE) {
    //     this.handleBtnActive(handlerId);
    //     return;
    //   }
    //   if (eventType === eventTypes.UNHOVER) {
    //     this.handleBtnUnhover(handlerId);
    //     return;
    //   }
    // },
    // handleHandEventComponent(eventType, handlerId) {
    //   this.btnClasses[handlerId] = eventType;
    // },
    // handleBtnHover(handlerId) {
    //   // TODO: Apply proper class(es) on the coresponding button
    //   this[handlerId] = 'hover';
    //   console.log(`hovered event received for button ${handlerId}`);
    // },
    // handleBtnUnhover(handlerId) {
    //   // TODO: Remove hover class(es) from the coresponding button
    //   this[handlerId] = 'unhover';
    //   console.log(`Unhovered event received for button ${handlerId}`);
    // },
    // handleBtnActive(handlerId) {
    //   // TODO: Remove hover class(es) from the coresponding button
    //   this[handlerId] = 'active';
    //   console.log(`active event received for button ${handlerId}`);
    // },
    routeToLevel(levelId) {
      alert('TODO: Route to level ' + levelId);
    }
  }
};
</script>

<style lang="scss" scoped>
.hoverable-button {
  border: 2px solid black;
  font-size: 10pt;
  background-color: white;
  position: absolute;
  padding: 5px;
  margin: 50px;
  border-radius: 10px;
  box-shadow: 3px 3px 10px -2px black;
  cursor: pointer;
  transition: 0.5s;
}

.hover,
.activate,
.hoverable-button:hover {
  font-size: 14pt;
  font-weight: bold;
}

.hover,
.hoverable-button:hover {
  background-color: yellow;
}

.activate {
  background-color: green;
}

.button-1-layout,
.button-2-layout {
  position: absolute;
  top: 30px;
  width: 100px;
  height: 100px;
  z-index: 100;
}

.button-1-layout {
  left: 30px;
}

.button-2-layout {
  right: 30px;
}
</style>
